import React, { Component } from 'react';
import Dropdown from './Dropdown';
import Prompt from './Prompt';
import Toggle from './Toggle';
import RadioGroup from './RadioGroup';
import loading from './assets/loading.gif';
import ReactGA from 'react-ga';
import { withTranslation, Trans } from 'react-i18next';
import { US_STATES } from './USStates';


class PdfForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            consent: false,
            expanded: true,
            promptType: 'info',
            promptText: '',
            email: '',
            telephone: '',
            name: '',
            surname: '',
            mayContact: true,
            interestOtherBoat: false,
            preownedBoat: false,
            timeFrame: undefined,
            NewsLetter: false,
            emailInvalid: false,
            telephoneInvalid: false,
            countryInvalid: false,
            nameInvalid: false,
            promptVisible: false,
            loading: false,
            country: props.country || '',
            usState: '',
            residentRegion: '',
            surnameInvalid: false
        };

        this.showPropmt = this.showPropmt.bind(this);
        this.downloadPdf = this.downloadPdf.bind(this);
        this.getPdf = this.getPdf.bind(this);
        this.requestPdf = this.requestPdf.bind(this);
        this.handleCountryChange = this.handleCountryChange.bind(this);

        this.timeFrameOptions = [
            { value: 1, label: this.props.t('Short term - 0-6 months') },
            { value: 2, label: this.props.t('Medium term - 6-12 months') },
            { value: 3, label: this.props.t('Long term - More than a year') }
        ];
    }

    componentWillUnmount() {
        clearTimeout(this.timer);
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search || '');
        if (params.get('autopdf') === '1') {
            // Use the same path as a manual "sailing" download.
            setTimeout(() => this.downloadPdf(), 300);
        }
    }
    
    removeMeta(obj) {
        for (var prop in obj) {
            if (prop === 'thumbnail') {
                delete obj[prop];
            } else if (prop === 'preview') {
                delete obj[prop];
            } else if (typeof obj[prop] === 'object') {
                this.removeMeta(obj[prop]);
            }
        }
    }

    validateEmail() {
        return (/^.+@.+\..+$/.test(this.state.email));
    }

    downloadPdf() {
        var clone = JSON.parse(JSON.stringify(this.props.configuration));
        this.removeMeta(clone);

        const form = document.createElement('form');
        form.setAttribute('method', 'post');
        form.setAttribute('action', '/'+this.props.boat+'/pdf');
        form.setAttribute('target', '_blank');

        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'configuration');
        input.setAttribute('value', JSON.stringify(clone));
        form.appendChild(input);

        const codeInput = document.createElement('input');
        codeInput.setAttribute('type', 'hidden');
        codeInput.setAttribute('name', 'code');
        codeInput.setAttribute('value', this.props.code);
        form.appendChild(codeInput);

        const gaInput = document.createElement('input');
        gaInput.setAttribute('type', 'hidden');
        gaInput.setAttribute('name', 'ga');
        ReactGA.ga((tracker) => {
            gaInput.setAttribute('value', tracker.get('clientId'));
        });
        
        form.appendChild(gaInput);

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }

    requestPdf() {
        this.setState({
            loading: true
        });

        var clone = JSON.parse(JSON.stringify(this.props.configuration));
        this.removeMeta(clone);
        var ga = "";

        ReactGA.ga((tracker) => {
            ga = tracker.get('clientId');
        });

        /*console.log("Country:", this.state.country);
        console.log("Region:", this.state.usState);
        */

        fetch('/' + this.props.boat +'/Send', {
            method: "POST",
            headers: {
                "Content-Type": "application/json; charset=utf-8"
            },
            body: JSON.stringify({
                configuration: clone,
                country: this.state.country,
                region: this.state.country.toUpperCase() === 'US' ? this.state.usState : '',
                residentRegion: this.state.country.toUpperCase() === 'US' ? this.state.residentRegion : '',
                name: this.state.name,
                surname: this.state.surname,
                email: this.state.email,
                telephone: this.state.telephone,
                mayContact: this.state.mayContact,
                interestOtherBoat: this.state.interestOtherBoat,
                preownedBoat: this.state.preownedBoat,
                code: this.props.code,
                timeFrame: this.state.timeFrame === undefined ? '' : this.state.timeFrame.label,
                ga: ga,
                NewsLetter: this.state.NewsLetter
            })
        })
            .then(function (response) {
                if (response.ok) {
                    return response;
                }
                throw new Error(this.props.t('Error prompt: Network response was not ok.'));
            })
            .then(response => {
                this.showPropmt("success", this.props.t("Info prompt: PDF sent"));
                this.setState({
                    loading: false
                });
            })
            .catch(reason => {
                this.showPropmt("error", this.props.t("Error prompt: PDF not sent"));
                this.setState({
                    loading: false
                });
            });
    }




    getPdf() {
        if (this.state.loading) {
            return;
        }

        // No change for the "sailing" shortcut.
        if (this.state.email === 'sailing') {
            this.downloadPdf();
        } else {
            // Directly invoke validation checks for email and telephone.
            const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email);
            const isTelephoneValid = /^[0-9+\-() ]*$/.test(this.state.telephone) && this.state.telephone.trim() !== '';

            this.setState({
                emailInvalid: !isEmailValid,
                countryInvalid: this.state.country === '',
                nameInvalid: this.state.name === '',
                surnameInvalid: this.state.surname.trim() === '',
                telephoneInvalid: !isTelephoneValid,
            }, () => {
                // After state updates, check if any validations failed.
                if (this.state.emailInvalid || this.state.countryInvalid || this.state.nameInvalid || this.state.surnameInvalid || this.state.telephoneInvalid) {
                    // If any field is invalid, prevent form submission.
                    return;
                } else {
                    // All validations passed, proceed with submitting the form.
                    this.requestPdf();
                }
            });
        }
    }






    showPropmt(type, text) {
        this.setState({
            promptType: type,
            promptText: text,
            promptVisible: true
        });

        this.timer = setTimeout(() => {
            this.setState({ promptVisible: false });
        }, 5000);
    }

    handleCountryChange(value) {
        this.setState({
            country: value.value,
            countryInvalid: false,
            // Reset US-state if not USA
            usState: value.value === 'US' ? this.state.usState : '',
            // Reset resident state if not USA
            residentRegion: value.value === 'US' ? this.state.residentRegion : ''
        });
    }

    handleTelephoneChange = (event) => {
        const value = event.target.value;
        // A simple validation for phone number: not empty and contains only numbers and optional common phone number characters (like +, -, spaces).
        const isValidPhoneNumber = value.match(/^[0-9+\-() ]*$/);

        // Update the state with the new value and whether the field is invalid.
        this.setState({
            telephone: value,
            telephoneInvalid: !value || !isValidPhoneNumber
        });
    }

    handleEmailChange = (event) => {
        const value = event.target.value;
        // Simple regex for basic email validation.
        const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

        // Update the state with the new value and whether the field is invalid.
        // The key here is to ensure this update happens correctly.
        this.setState({
            email: value, // Ensure this is always updated regardless of validity
            emailInvalid: !isValidEmail, // Then set the validity based on the current value
        });
    };





    render() {
        return (
            <div>
                <h2><Trans defaults='Get your configuration as pdf' /></h2>
                <p><Trans defaults='PDF Configuration Text' /></p>

                <Prompt type={this.state.promptType} visible={this.state.promptVisible}>{this.state.promptText}</Prompt>

                <Dropdown
                    placeholder={this.props.t("Select country...")}
                    className={this.state.countryInvalid ? 'invalid' : ''}
                    value={this.props.countries.find(c => c.value === this.state.country)}
                    options={this.props.countries}
                    onChange={this.handleCountryChange}
                />

                <p>
                    <input
                        name="firstname"
                        type="text"
                        className={this.state.nameInvalid ? 'invalid' : ''}
                        value={this.state.name}
                        onChange={(event) => { this.setState({ name: event.target.value, nameInvalid: false }); }}
                        placeholder={this.props.t("Name")} />

                    <input
                        name="lastname"
                        type="text"
                        value={this.state.surname}
                        className={this.state.surnameInvalid ? 'invalid' : ''}
                        onChange={(event) => { this.setState({ surname: event.target.value, surnameInvalid: event.target.value.trim() === '' }); }}
                        placeholder={this.props.t("Surname")} />
                    <input
                        name="telephone"
                        type="text"
                        className={this.state.telephoneInvalid ? 'invalid' : ''}
                        value={this.state.telephone}
                        onChange={this.handleTelephoneChange} 
                        placeholder={this.props.t("Mobile number")} required />
                    <input
                        name="email"
                        placeholder={this.props.t("Email")}
                        className={this.state.emailInvalid ? 'invalid' : ''}
                        type="email" value={this.state.email}
                        onChange={this.handleEmailChange}
                        style={{ width: 262, verticalAlign: 'top', marginRight: 10 }} />
                </p>

                {this.state.country === 'us' && (
                    <p>Which state is the healing port? </p>
                )}
                {this.state.country === 'us' && (
                    <Dropdown
                        placeholder={this.props.t("Select state...")}
                        value={US_STATES.find(s => s.value === this.state.usState)}
                        options={US_STATES.map(state => ({
                            value: state.value,
                            label: state.label,
                            key: state.value, // <- Ensures unique keys
                        }))}
                        onChange={(selected) => this.setState({ usState: selected.value })}
                    />
                )}

                {this.state.country === 'us' && (
                    <p>Which state are you living?</p>
                )}
                {this.state.country === 'us' && (
                    <Dropdown
                        placeholder={this.props.t("Select state...")}
                        value={US_STATES.find(s => s.value === this.state.residentRegion)}
                        options={US_STATES.map(state => ({
                            value: state.value,
                            label: state.label,
                            key: state.value, // <- Ensures unique keys
                        }))}
                        onChange={(selected) => this.setState({ residentRegion: selected.value })}
                    />
                )}
                
                <h3>{this.props.t('Please answer the following:')}</h3>

                <Toggle onChange={(event) => { this.setState({ NewsLetter: event.target.checked }); }}> {this.props.t('I would like to recieve X-Yachts newsletter and yearly magazine')}</Toggle>
                <Toggle onChange={(event) => { this.setState({ interestOtherBoat: event.target.checked }); }}> {this.props.t('I am considering a new boat')}</Toggle>
                {this.props.disablePreowned ? null :
                    <Toggle onChange={(event) => { this.setState({ preownedBoat: event.target.checked }); }}> {this.props.t('A pre-owned boat is an option for me')}</Toggle>
                }

                <h3><Trans defaults='My timeframe is:' /></h3>
                <RadioGroup options={this.timeFrameOptions} value={this.state.timeFrame} onChange={(option) => { this.setState({ timeFrame: option }); }} />

                
                <div className={"expander" + (this.state.expanded ? " open" : " closed")}>
                    <Toggle
                        className="toggle-consent"
                        onChange={(event) => { this.setState({ consent: event.target.checked }); }}
                    >
                        {this.props.t('PDF Configuration Disclaimer Text')}
                    </Toggle>
                    <button
                        className="button"
                        onClick={this.getPdf}
                        disabled={!this.state.consent || this.state.loading}
                        style={{ opacity: (!this.state.consent || this.state.loading) ? 0.5 : 1, cursor: (!this.state.consent || this.state.loading) ? 'not-allowed' : 'pointer' }}
                    >
                        {this.state.loading ? <img src={loading} alt="loading" style={{ marginLeft: 12, marginRight: 13 }} /> : <Trans defaults='Send' />}
                    </button>
                </div>

            </div>
        );
    }
}

export default withTranslation()(PdfForm);



// WEBPACK FOOTER //
// ./src/PdfForm.js